import * as React from "react";
const SvgPhone = () => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.041 2.47a.75.75 0 0 1 1.06 0l4.286 4.285a.75.75 0 0 1 0 1.061l-2.04 2.041 5.796 5.797 2.041-2.041a.75.75 0 0 1 1.06 0l4.286 4.285a.75.75 0 0 1 0 1.06L18.96 21.53a.75.75 0 0 1-.53.22C9.494 21.75 2.25 14.507 2.25 5.571a.75.75 0 0 1 .22-.53zm.53 1.59L3.753 5.88c.162 7.862 6.506 14.206 14.368 14.368l1.818-1.818-3.225-3.225-2.04 2.04a.75.75 0 0 1-1.061 0l-6.858-6.857a.75.75 0 0 1 0-1.06l2.041-2.041z",
    clipRule: "evenodd"
  }
));
export default SvgPhone;
